import { _ as r } from "../internals/export.js";
import { a as t } from "../internals/add-to-unscopables.js";
import { d as o } from "../internals/does-not-exceed-safe-integer.js";
import { l as e } from "../internals/length-of-array-like.js";
import { t as a } from "../internals/to-absolute-index.js";
import { t as n } from "../internals/to-indexed-object.js";
import { t as i } from "../internals/to-integer-or-infinity.js";
var s = Array,
  m = Math.max,
  l = Math.min;
r({
  target: "Array",
  proto: !0
}, {
  toSpliced: function toSpliced(r, t) {
    var f,
      p,
      d,
      j,
      c = n(this),
      g = e(c),
      h = a(r, g),
      x = arguments.length,
      u = 0;
    for (0 === x ? f = p = 0 : 1 === x ? (f = 0, p = g - h) : (f = x - 2, p = l(m(i(t), 0), g - h)), j = s(d = o(g + f - p)); u < h; u++) j[u] = c[u];
    for (; u < h + f; u++) j[u] = arguments[u - h + 2];
    for (; u < d; u++) j[u] = c[u + p - f];
    return j;
  }
}), t("toSpliced");